import { type RefObject, useCallback } from 'react'
import type { Group, Quaternion, Vector3 } from 'three'

type UseApplyAvatarPresentationFrameParams = {
  groupRef: RefObject<Group | null>
}

type ApplyFrameParams = {
  targetPosition: Vector3
  targetQuaternion: Quaternion
  nextScale: number
  shouldSnap: boolean
  lerpAlpha: number
}

export const useApplyAvatarPresentationFrame = ({ groupRef }: UseApplyAvatarPresentationFrameParams) => {
  const applyFrame = useCallback(
    ({ targetPosition, targetQuaternion, nextScale, shouldSnap, lerpAlpha }: ApplyFrameParams) => {
      const group = groupRef.current
      if (!group) return false

      /** 初期表示/resize 時はスナップ、それ以外は lerp で補間する */
      if (shouldSnap) {
        group.position.copy(targetPosition)
        group.quaternion.copy(targetQuaternion)
        group.scale.setScalar(nextScale)
      } else {
        group.position.lerp(targetPosition, lerpAlpha)
        /** 回転とスケールは通常時だけ滑らかに補間する */
        group.quaternion.slerp(targetQuaternion, lerpAlpha)
        group.scale.setScalar(nextScale)
      }

      return true
    },
    [groupRef]
  )

  return {
    applyFrame,
  }
}
